var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',{directives:[{name:"resize",rawName:"v-resize",value:(_vm.handleResize),expression:"handleResize"}],attrs:{"full-height":""}},[_c('app-bar'),_c('v-main',{class:_vm.$style.main},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }